import { useQuery } from "react-query";
import { fetchPatientAppointments } from "@/services/appointments";
import { EMR_TIMEZONE } from "@/constants/emr";
/** Query hook for a patient's appointments with optional filters. */
export function usePatientAppointments(workspaceId, patientId, filters) {
  return useQuery(["patient-appointments", workspaceId, patientId, filters !== null && filters !== void 0 ? filters : {}], function () {
    return fetchPatientAppointments(workspaceId, patientId, EMR_TIMEZONE, filters);
  }, {
    enabled: Boolean(workspaceId && patientId),
    keepPreviousData: true,
    staleTime: 5 * 60 * 1000,
    retryOnMount: false,
    notifyOnChangeProps: "tracked"
  });
}